module.exports = __webpack_public_path__ + "public/images/about-13.9a5b08beaab46a9ba3bb18bf2826fe9d.jpg";